import { jwtDecode } from 'jwt-decode';

// Function to check if the token is valid (Only check if expired or not)
export const isAccessTokenValid = (token) => {
	try {
		if (!token) {
			return false; // Token is missing
		}
		if (token) {
			const decodedToken = jwtDecode(token);
			const currentTime = Date.now() / 1000; // Get current time in seconds
			// console.log(decodedToken.exp + ' ==> Token Expiration');
			// console.log(Math.floor(currentTime) + ' ==> Current Time')

			if (decodedToken.exp < currentTime) {
				// console.log('Token Expired');
				localStorage.removeItem('accessToken');
				return false; // Token has expired
			}

			return true; // Token is still valid
		}
	} catch (error) {
		console.error('Error decoding token:', error);
		return false; // Error decoding token
	}
}; 